<template>
  <div id="app">

      <search-bar ref="searchBarComponent">
        <div slot="search-tool">
          <el-button class="item-btn el-icon-plus" type="primary" @click="dialogVisible = true">新增</el-button>
        </div>
        <div slot="search-cont">
          <div class="item" style="width: 50%;">
            <div class="item-label">关键词搜索</div>
            <div style="width: 300px;">
              <el-input placeholder="请输入内容" v-model="info.key" class="input-with-select" size="small"  @keyup.enter.native='searchResume'>
                <el-select v-model="info.key_type" slot="prepend" placeholder="请选择" style="width: 130px" size="small">
                  <el-option label="电话号码" value="1"></el-option>
                  <el-option label="备注" value="2"></el-option>
                </el-select>
                <el-button slot="append" icon="el-icon-search" @click='searchResume' size="small"></el-button>
              </el-input>
            </div>
          </div>
        </div>
      </search-bar>
      <div class="operation-tool">
        <div @click="dialogVisible = true" class="tool-item"> <img src="../../../static/img/btn/add.png" /> 新增</div>

      </div>
      <div class="l-panel">
        <div class="panel-body">
        <el-table class="l-table-new" :data="tableData" style="width: 100%;" border :max-height="300">
          <el-table-column prop="id" label="id" align='center'></el-table-column>
          <el-table-column prop="mobile" label="电话" align='center'></el-table-column>
          <el-table-column prop="remark" label="备注" align='center'></el-table-column>
          <el-table-column prop="addtime" label="录入时间" align='center'></el-table-column>
          <el-table-column prop="addtime" label="操作" align='center'>
            <template slot-scope='{row}'>
              <el-button type="primary" @click='removeBlack(row.mobile,row.id)'>移除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="c-table-pager">
          <el-pagination  :total="total" @current-change='paginationChange'> </el-pagination>
        </div>



        <el-dialog  title="新增黑名单"  :visible.sync="dialogVisible" center width="30%">
          <el-form ref="form" :model="form" label-width="80px">
            <el-form-item label="手机号">
              <el-input v-model="form.mobile" type="number" oninput="if(value.length>11)value=value.slice(0,11)" />
            </el-form-item>
            <el-form-item label="备注">
              <el-input v-model="form.remark" type="text" />
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="submitForm">确 定</el-button>
          </span>
        </el-dialog>
        </div>
      </div>


  </div>
</template>

<script>
  import Message from '@/utils/message.js';
  export default {
    data() {
      return {
        info: {
          key_type: '1',
          key: '',
          page: 1
        },
        form: {
          mobile:'',
          remark:''
        },
        tableData: [],
        total: 1,
        dialogVisible:false
      }
    },
    created() {
          this.$nextTick(() => {
            document.onselectstart = new Function("event.returnValue=false");
          });
    },
    mounted() {
      this.getData()
    },

    methods: {
      searchResume() {
        if(!this.info.key_type){
          return Message.warning('请选择类型')
        }
        this.info.page = 1
        this.getData()
      },

      paginationChange(val){
        this.info.page = val
        this.getData()
      },

      getData() {
        this.gets('oasystem/blacklist', this.info).then(res => {
          this.tableData = res.data.data.list
          this.total = res.data.data.total
        })
      },

      submitForm(){
        let that = this
        if(this.form.mobile){
          let myreg=/^[1][3,4,5,7,8,9][0-9]{9}$/;
          if (!myreg.test(this.form.mobile)){
            return Message.warning('请输入正确电话号码')
          }
          this.post('oasystem/blackAdd',this.form)
          .then(res=>{
            that.getData()
            res.data.code == 1 ? Message.success(res.data.msg) : Message.warning(res.data.msg)
            this.dialogVisible = res.data.code == 1 ? false : true
            })
        }else{
          Message.warning('请输入电话号码')
        }
      },

      removeBlack(phone,id){
        let that = this
        this.$confirm('确定从黑名单移除' + phone +'?','提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(res=>{
           this.post('oasystem/blackDelete',{id})
           .then(res=>{
             res.data.code == 1 ? Message.success(res.data.msg) : Message.warning(res.data.msg)
             that.getData()
           })
        })
      },
    }
  }
</script>

<style scoped>
  .table {
    background: #fff;
    padding: 20px;
    box-sizing: border-box;
  }
  .pagination {
    margin-top: 20px;
    text-align: center;
    padding: 20px 0;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }
  .totalNumber {
    height: 50px;
    padding: 0 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
</style>



// WEBPACK FOOTER //
// src/view/oasystem/blacklist.vue